<template>
  <div class="m-header">
    <img
      v-if="extras && extras.navLogo && extras.navLogo.display == 1"
      :src="
        extras && extras.navLogo.src ? extras.navLogo.src : imgUrlObj.wap.logo
      "
      alt=""
      class="logo"
    />
    <div class="info">
      <p v-show="!isLogin && seminarInfo && seminarInfo.isOpenMember == 1">
        <span class="login-btn" @click="goto('login')"> 登录 </span>
        <span class="info-separate">|</span>
        <span class="register-btn" @click="goto('register')"> 注册 </span>
      </p>
      <img
        class="member-header"
        v-if="isLogin && seminarInfo.isOpenMember != 0"
        :src="memberInfo.headImg || imgUrlObj.wap.header"
        @click="gotoUserCenter"
      />
      <img
        class="menu-class"
        src="@/assets/images/wap/more.png"
        alt=""
        @click="ShowCLick()"
      />
    </div>
    <div class="nav" v-if="show">
      <span
        v-for="(item, index) in list"
        :key="index"
        v-show="extras[item.key].display == 1"
        @click="JumpClick(item)"
        >{{ extras[item.titleKey].model || item.title }}</span
      >
    </div>
  </div>
</template>

<script>
import { URLS } from "fire-wind-water";
import { goto } from "../../mixins/goto";
// import Api from "@/service/api";
export default {
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    extras: Object,
    loginUrl: String,
    registerUrl: String,
  },
  data() {
    return {
      show: false,
      isLogin: false,
      list: [
        {
          title: "大会简介",
          key: "introduction",
          titleKey: "introductionTitle",
        },
        {
          title: "会议日程",
          key: "meetingAgenda",
          titleKey: "meetingAgendaTitle",
        },
        {
          title: "参会嘉宾",
          key: "meetingGuest",
          titleKey: "meetingGuestTitle",
        },
        { title: "新闻资讯", key: "message", titleKey: "messageTitle" },
        { title: "合作伙伴", key: "partner", titleKey: "partnerTitle" },
        { title: "资料下载", key: "download", titleKey: "downloadTitle" },
      ],
      imgUrlObj: {
        wap: {
          logo: require("@/assets/images/wap/logo.png"),
          header: require("@/assets/images/wap/my.png"),
        },
        backgroundColor: {
          value: "#135ed8",
        },
      },
    };
  },
  created() {
    const { tenantId, schemaId, memberFormId } = this.seminarInfo;
    // const { usercenterUrl } = window.config;
    this.userCenterUrl = `index.html?tenantId=${tenantId}&schemaId=${schemaId}&memberFormId=${memberFormId}`;
    // this.userCenterUrl = `${usercenterUrl}index.html?tenantId=${tenantId}&schemaId=${schemaId}&memberFormId=${memberFormId}`;
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    if (URLS.getURL("isSetting") == 1) {
      this.isLogin = false;
    }
    console.log("会议信息", this.seminarInfo);
  },
  mounted() {
    let _this = this;
    document.addEventListener("click", function (e) {
      // 下面这句代码是获取 点击的区域是否包含你的菜单，如果包含，说明点击的是菜单以外，不包含则为菜单以内
      let flag = e.target.contains(
        document.getElementsByClassName("menu-class")[0]
      );
      console.log(flag);
      if (flag) {
        // eslint-disable-next-line no-self-assign
        _this.show = _this.show;
      } else {
        _this.show = false;
      }
    });
  },
  methods: {
    goto(s) {
      switch (s) {
        case "login":
          goto.login();
          break;
        case "register":
          goto.register();
          break;
      }
    },
    gotoUrl: function (url) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (url) {
        window.$sk.goto(url);
        // window.$sk.goto(url);
      }
    },
    gotoUserCenter: function () {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      // Api.getDomain(this.seminarInfo.tenantId).subscribe((res) => {
      //   if (res.result === 0) {
      //     window.location.href = `//${res.content.domain}/usercenter/${this.userCenterUrl}`;
      //   }
      // });
      window.$sk.goto(
        `${window.$sk.config.usercenterUrl}${this.userCenterUrl}`
      );
    },
    JumpClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.number = item.key;
      this.$emit("routerEvent", item);
      this.show = false;
    },
    ShowCLick() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.show = !this.show;
    },
  },
};
</script>
<style scoped></style>
